import { React, useContext, useEffect, useState ,useMemo} from 'react'
import { useParams, NavLink, useLocation } from 'react-router-dom';
import { AcquirerDetail } from "../../Config/config"
import ComparePopUp from '../../Pages/ComparePopUp'
import Constants from '../../Constants';
import { UserContext } from '../../Contexts/UserContext';
import axios from 'axios';
import moment from 'moment';
import AcquirerDetailInformation from './AcquirerDetailInformation';
import { routeNames } from '../../routeSegments';
import CurrencyContextProvider from '../../Contexts/CurrencyContext';
import AllAcquistions from './AllAcquisitions';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MonthPickerComponent from '../../Utils/MonthPickerComponent';
import AcquirerDetailInfo from './AcquirerDetailInfo';


/**
 * The AcquirersDetail component is a React component that displays information about a specific
 * acquirer, including an overview, acquisitions, and recent news and activity.
 */
const AllAcquirersDetail = () => {
    
    const [showModal, setShowModal] = useState(false);
    const [profileData, setProfileData] = useState({});
    const { getToken, logout } = useContext(UserContext);
    const location = useLocation();
    const { acquirerId } = useParams();
    const [isLoading, setIsLoading] = useState(true)
    const { setMonthPickerValue } = useContext(PeFilterContext)

    useEffect(() => {
        setMonthPickerValue(["2004-01-01", moment().endOf("month").format("YYYY-MM-DD")])
        setIsLoading(true);
        const abortController = new AbortController()
        axios(`${AcquirerDetail}`, {
            method: "POST",
            data: {
                acquirer_id: [acquirerId],
                type: Constants.primaryMasterIds.mANDaId
            },
            signal: abortController.signal, 
            headers: {
                "Content-Type": "application/json",
                "Authorization": getToken()
            },
        })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.status== 200) {                
                    console.log("acquirerProfileData", response);
                    setProfileData(response.data?.acquirer_details);
                } 
            })
            .catch((error) => {
                console.log("API not working", error);
                if (error?.response?.status == Constants.sessionTerminatedStatus) {
                    logout()
                }
            });

        return () => {
            abortController.abort()
        }
    }, [acquirerId, getToken, logout])

    document.title = `${profileData?.top_profile?.acquirer_name ? profileData?.top_profile?.acquirer_name + " - " : ""}M&A Acquirers - Venture Intelligence`;

    return (
      
         <CurrencyContextProvider>
         <div className="bg-[#FFFFFF] relative">
             <nav className="flex p-1 border-b " aria-label="Breadcrumb">
                 <ol className="flex items-center space-x-1">
                     <li className='flex items-center'>
                         <div className='flex items-center'>
                             <NavLink state={location.state?.prevPath} to={location.state?.prevPath != null && location.state?.prevPath !=""
                                 ? location.state?.prevPath
                                 : routeNames.ma_acquires}
                                 className="ml-2 text-[11pt] lg:text-[12px] text-[#666666] font-sans_book_body">
                                 Acquirers
                             </NavLink>
                         </div>
                     </li>
                     <li className="flex items-center"><div className="flex items-center"><span className=" text-[12px] text-[#666666] mr-1">/</span><span className=" text-[11pt] lg:text-[12px] text-[#666666] font-semibold" aria-current="page">{profileData?.top_profile?.acquirer_name}</span></div></li>
                 </ol>
             </nav>
             <AcquirerDetailInfo data={profileData?.top_profile} id={acquirerId} page="companyPage" cname={profileData?.top_profile?.acquirer_name} type="ma" />

             <div className="bg-[#EDEDED]">
                 <div className="bg-[#EDEDED] h-full space-y-5">
                    <AllAcquistions isLoading={isLoading} acquirers={profileData?.acquistions_funds} acquirerName={profileData?.top_profile?.acquirer_name}/>
                 </div>
             </div>
             {showModal ? (<ComparePopUp id={acquirerId} onClose={(e) => setShowModal(false)} />) : null}
         </div>
     </CurrencyContextProvider>

    )

}

export default AllAcquirersDetail